import React from "react";
import ReversalPage from ".";
import DrawerLayout from "../../components/DrawerLayout";
import EditEstorno from "./reversal-edit";
import ProtectedRoute from "../../hooks/ProtectedRoute";
import ReversalForm from "./reversal-form";
import RevesalImport from "./reversal-import";
import ReversalDownload from "./reversal-download/intex";

const useHomeRoutes = (props: any) => {
  const routers = React.useMemo(
    () => [
      {
        path: "/reversal",
        element: (
          <ProtectedRoute 
          outlet={
              <DrawerLayout colorMode={props}>
                <ReversalPage />
          </DrawerLayout>
          }
        />
        ),
      },
      {
        path: "/reversal-n1/:id",
        element: (
                <ReversalPage />     
        ),
      },
      {
        path: "/reversal-details",
        element: (
          <ProtectedRoute 
          outlet={
            <DrawerLayout colorMode={props}>
              <EditEstorno />
            </DrawerLayout>
              }
              />
        ),
      },
      {
        path: "/form-image",
        element: (
          <ProtectedRoute 
          outlet={
            <DrawerLayout colorMode={props}>
              <ReversalForm />
            </DrawerLayout>
              }
              />
        ),
      },
      {
        path: "/uploadForms",
        element: (
          <ProtectedRoute 
          outlet={
            <DrawerLayout colorMode={props}>
              <RevesalImport />
            </DrawerLayout>
              }
              />
        ),
      },
      {
        path: "/reversalDownload/:case/:type",
        element: (
          <ProtectedRoute
            outlet={<ReversalDownload />}
          />
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return routers;
};

export default useHomeRoutes;
